<template>
  <div v-bind="$attrs">
    <label v-if="label" :class="labelClass">
      <input
        type="radio"
        :name="name"
        :checked="modelValue === value"
        :value="value"
        :class="inputClass"
        @change="$emit('input', value)"
      />
      {{ label }}
    </label>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      required: true
    },
    inputClass: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  }
}
</script>
